import React from "react";
import { Typography, Toolbar } from "@material-ui/core";

function MyFooter(props) {
  return (
    <Toolbar className={"footer"}>
      <img
        className={"footer-logo"}
        src="https://invisionweb.in/site/static/media/invision.2acab5b0.png"
      />
      <Typography variant="overline">
        Powered by <a className="App-link" href="http://invisionweb.in">Invision</a> &copy; {new Date().getFullYear()}
      </Typography>
    </Toolbar>
  );
}

export default MyFooter;
